import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ediciones from './ediciones'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ediciones,
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
})
